import { render, staticRenderFns } from "./WarehouseCardOderInfo.vue?vue&type=template&id=198621d4&"
import script from "./WarehouseCardOderInfo.vue?vue&type=script&lang=js&"
export * from "./WarehouseCardOderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports